// Коды ошибок прикладных операций. API отдаёт их в OperationResult.messages
// и fieldErrors, интерфейс переводит их словарём errors.* (контекст system).
export enum ErrorCode {
  // Общие
  BadRequest = 'BAD_REQUEST',
  Unauthorized = 'UNAUTHORIZED',
  Forbidden = 'FORBIDDEN',
  NotFound = 'NOT_FOUND',
  ValidationFailed = 'VALIDATION_FAILED',
  InternalError = 'INTERNAL_ERROR',

  // identity
  InvalidCredentials = 'INVALID_CREDENTIALS',
  LoginThrottled = 'LOGIN_THROTTLED',
  UserDisabled = 'USER_DISABLED',
  LoginInvalid = 'LOGIN_INVALID',
  LoginTaken = 'LOGIN_ALREADY_EXISTS',
  PasswordTooShort = 'PASSWORD_TOO_SHORT',
  CurrentPasswordInvalid = 'CURRENT_PASSWORD_INVALID',
  DisplayNameInvalid = 'DISPLAY_NAME_INVALID',
  UserNotFound = 'USER_NOT_FOUND',
  LastAdmin = 'LAST_ADMIN',
  CannotDisableSelf = 'CANNOT_DISABLE_SELF',
  // identity: ключи API (ADR-015)
  ApiKeyNotFound = 'API_KEY_NOT_FOUND',
  /** IAM-UC-12.CC-2: маршрута нет в API для интеграций или у ключа нет нужной области. */
  ApiKeyScopeDenied = 'API_KEY_SCOPE_DENIED',
  ApiKeyNameInvalid = 'API_KEY_NAME_INVALID',
  ApiKeyScopesInvalid = 'API_KEY_SCOPES_INVALID',
  ApiKeyLimitReached = 'API_KEY_LIMIT_REACHED',
  /** IAM-UC-13.CC-1: удалить можно только отозванный ключ. */
  ApiKeyActive = 'API_KEY_ACTIVE_IN_USE',
  // identity: регистрация (IAM-UC-14)
  /** IAM-UC-14.CC-1: функция «Свободная регистрация» выключена. */
  RegistrationDisabled = 'REGISTRATION_DISABLED',
  /** IAM-UC-14.CC-3: превышен предел регистраций в час на платформе. */
  RegistrationThrottled = 'REGISTRATION_THROTTLED',
  /** IAM-UC-14.CC-2: пароль и его повтор различаются — проверка формы до отправки. */
  PasswordMismatch = 'PASSWORD_MISMATCH',

  // workspaces
  BlogNotFound = 'BLOG_NOT_FOUND',
  BlogNameInvalid = 'BLOG_NAME_INVALID',
  TimezoneInvalid = 'TIMEZONE_INVALID',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  MemberExists = 'MEMBER_ALREADY_EXISTS',
  LastOwner = 'LAST_OWNER',
  /** WS-UC-5.CC-2: аккаунт блога нельзя исключить или понизить. */
  BlogAccountMember = 'BLOG_ACCOUNT_MEMBER',

  // entities: определения
  EntityTypeNotFound = 'ENTITY_TYPE_NOT_FOUND',
  EntityTypeNameInvalid = 'ENTITY_TYPE_NAME_INVALID',
  EntityTypeHasEntities = 'ENTITY_TYPE_HAS_ENTITIES_IN_USE',
  EntityTypeReferenced = 'ENTITY_TYPE_REFERENCED_IN_USE',
  FieldDefinitionInvalid = 'FIELD_DEFINITION_INVALID',
  FieldKeyDuplicate = 'FIELD_KEY_ALREADY_EXISTS',
  FieldTypeChangeForbidden = 'FIELD_TYPE_CHANGE_FORBIDDEN',
  TitleFieldInvalid = 'TITLE_FIELD_INVALID',
  SelectOptionsRequired = 'SELECT_OPTIONS_REQUIRED',
  ReferenceTargetInvalid = 'REFERENCE_TARGET_INVALID',
  // entities: записи и значения
  EntityNotFound = 'ENTITY_NOT_FOUND',
  EntityReferenced = 'ENTITY_REFERENCED_IN_USE',
  FieldRequired = 'FIELD_REQUIRED',
  FieldTooLong = 'FIELD_TOO_LONG',
  FieldMultiline = 'FIELD_MULTILINE',
  FieldNotNumber = 'FIELD_NOT_NUMBER',
  /** Число вне границ параметра (проверка форм, например пережатия — MED-UC-9). */
  FieldOutOfRange = 'FIELD_OUT_OF_RANGE',
  FieldRatingInvalid = 'FIELD_RATING_INVALID',
  FieldNotBoolean = 'FIELD_NOT_BOOLEAN',
  FieldDateInvalid = 'FIELD_DATE_INVALID',
  FieldUrlInvalid = 'FIELD_URL_INVALID',
  FieldOptionInvalid = 'FIELD_OPTION_INVALID',
  FieldReferenceInvalid = 'FIELD_REFERENCE_INVALID',

  // posts
  PostNotFound = 'POST_NOT_FOUND',
  PostTitleInvalid = 'POST_TITLE_INVALID',
  PostHasPublications = 'POST_HAS_PUBLICATIONS_IN_USE',
  PostStatusNotFound = 'POST_STATUS_NOT_FOUND',
  StatusNameInvalid = 'STATUS_NAME_INVALID',
  StatusColorInvalid = 'STATUS_COLOR_INVALID',
  StatusLastOfMeta = 'STATUS_LAST_OF_META',
  StatusReplacementRequired = 'STATUS_REPLACEMENT_REQUIRED',
  StatusOrderInvalid = 'STATUS_ORDER_INVALID',
  HashtagInvalid = 'HASHTAG_INVALID',
  MediaDuplicateInPost = 'MEDIA_DUPLICATE_IN_POST',
  /** POST-UC-14.CC-1: отмечено медиа, которого нет в списке медиа поста. */
  PostMediaExcludedUnknown = 'POST_MEDIA_EXCLUDED_UNKNOWN',
  /** POST-UC-1.CC-2: внешний клиент создаёт пост только с меткой источника. */
  PostSourceRequired = 'POST_SOURCE_REQUIRED',
  PostSourceInvalid = 'POST_SOURCE_INVALID',
  /** POST-UC-1.CC-3: дата создания позже текущего момента или не дата. */
  PostCreatedAtInvalid = 'POST_CREATED_AT_INVALID',
  /** POST-RULE-1: пост изменился после того, как клиент его прочитал (If-Match). */
  PostChanged = 'POST_CHANGED',
  /** POST-UC-10, POST-UC-10.CC-1, POST-UC-11.CC-1: правила оформления. */
  PostFormatNotFound = 'POST_FORMAT_NOT_FOUND',
  PostFormatNameInvalid = 'POST_FORMAT_NAME_INVALID',
  PostFormatNameTaken = 'POST_FORMAT_NAME_ALREADY_EXISTS',
  PostFormatDefaultRequired = 'POST_FORMAT_DEFAULT_REQUIRED',

  // media
  MediaNotFound = 'MEDIA_NOT_FOUND',
  MediaTypeUnsupported = 'MEDIA_TYPE_UNSUPPORTED',
  MediaTooLarge = 'MEDIA_TOO_LARGE',
  MediaEmpty = 'MEDIA_EMPTY',
  MediaNameRequired = 'MEDIA_NAME_REQUIRED',
  MediaInUse = 'MEDIA_ATTACHED_IN_USE',
  MediaNoteTooLong = 'MEDIA_NOTE_TOO_LONG',
  MediaTrafficLimitExceeded = 'MEDIA_TRAFFIC_LIMIT_EXCEEDED',
  // media: пережатие исходников (MED-UC-9)
  /** MED-UC-9.CC-6: на сервере нет обработчика медиа. */
  MediaRecompressUnavailable = 'MEDIA_RECOMPRESS_UNAVAILABLE',
  /** MED-UC-9.CC-6: формата нет в ffmpeg сервера. */
  MediaRecompressTargetUnsupported = 'MEDIA_RECOMPRESS_TARGET_UNSUPPORTED',
  /** MED-UC-9.CC-1: в выбранных форматах нет файлов. */
  MediaRecompressNothing = 'MEDIA_RECOMPRESS_NOTHING',
  /** MED-UC-9.CC-4: ошибки шага пережатия — в отчёт задачи. */
  MediaFileMissing = 'MEDIA_FILE_MISSING',
  MediaDecodeFailed = 'MEDIA_DECODE_FAILED',
  MediaEncodeFailed = 'MEDIA_ENCODE_FAILED',
  MediaVerifyFailed = 'MEDIA_VERIFY_FAILED',
  MediaHdrUnsupported = 'MEDIA_HDR_UNSUPPORTED',
  MediaProcessingTimeout = 'MEDIA_PROCESSING_TIMEOUT',
  /** TASK-UC-5: ffmpeg пропал — задача приостанавливается. */
  MediaProcessorUnavailable = 'MEDIA_PROCESSOR_UNAVAILABLE',
  /** TASK-UC-5: во временном каталоге нет места для файла и результата. */
  TempDiskFull = 'TEMP_DISK_FULL',

  // channels
  ChannelNotFound = 'CHANNEL_NOT_FOUND',
  ChannelNameInvalid = 'CHANNEL_NAME_INVALID',
  ChannelUrlInvalid = 'CHANNEL_URL_INVALID',
  ChannelHasPublications = 'CHANNEL_HAS_PUBLICATIONS_IN_USE',
  ChannelInScheme = 'CHANNEL_IN_SCHEME_IN_USE',
  SlotInvalid = 'SLOT_INVALID',

  // scheduling
  SchemeNotFound = 'SCHEME_NOT_FOUND',
  SchemeNameInvalid = 'SCHEME_NAME_INVALID',
  SchemeStepsInvalid = 'SCHEME_STEPS_INVALID',
  SchemeChannelInvalid = 'SCHEME_CHANNEL_INVALID',
  SchemeChannelDuplicate = 'SCHEME_CHANNEL_DUPLICATE',
  SchemeInUse = 'SCHEME_IN_USE',
  PostNotReady = 'POST_NOT_READY',
  PostAlreadyScheduled = 'POST_ALREADY_SCHEDULED',
  TimeInPast = 'TIME_IN_PAST',
  QueueItemNotFound = 'QUEUE_ITEM_NOT_FOUND',
  QueueOrderInvalid = 'QUEUE_ORDER_INVALID',

  // publishing
  PublicationNotFound = 'PUBLICATION_NOT_FOUND',
  PublicationNotPlanned = 'PUBLICATION_NOT_PLANNED',
  PublicationNotDue = 'PUBLICATION_NOT_DUE',
  PublicationFinal = 'PUBLICATION_ALREADY_FINAL',
  PublicationNotPublished = 'PUBLICATION_NOT_PUBLISHED',
  PublishedUrlInvalid = 'PUBLISHED_URL_INVALID',
  PublishedAtInFuture = 'PUBLISHED_AT_IN_FUTURE',

  // plans (PLAN-UC-1…6)
  PlanNotFound = 'PLAN_NOT_FOUND',
  PlanNameInvalid = 'PLAN_NAME_INVALID',
  PlanDescriptionInvalid = 'PLAN_DESCRIPTION_INVALID',
  PlanCodeInvalid = 'PLAN_CODE_INVALID',
  PlanCodeTaken = 'PLAN_CODE_ALREADY_EXISTS',
  PlanLimitInvalid = 'PLAN_LIMIT_INVALID',
  /** PLAN-RULE-2, PLAN-RULE-3: архивный план нельзя назначить и сделать планом по умолчанию. */
  PlanArchived = 'PLAN_ARCHIVED',
  /** PLAN-RULE-2: план по умолчанию нельзя отправить в архив. */
  PlanDefaultArchive = 'PLAN_DEFAULT_IN_USE',
  /** PLAN-UC-6: исчерпан лимит плана аккаунта блога. */
  PlanLimitBlogs = 'PLAN_LIMIT_BLOGS',
  PlanLimitEditors = 'PLAN_LIMIT_EDITORS',
  PlanLimitStorage = 'PLAN_LIMIT_STORAGE',
  PlanLimitMediaPerDay = 'PLAN_LIMIT_MEDIA_PER_DAY',
  PlanLimitPostsPerDay = 'PLAN_LIMIT_POSTS_PER_DAY',

  // tasks (TASK-UC-1…6)
  TaskNotFound = 'TASK_NOT_FOUND',
  /** TASK-UC-1.CC-1: в блоге уже есть незавершённая задача. */
  TaskAlreadyActive = 'TASK_ALREADY_ACTIVE',
  /** TASK-UC-4.CC-1: задача уже завершена или отменена. */
  TaskAlreadyFinished = 'TASK_ALREADY_FINISHED',
  /** TASK-UC-5.CC-2: возобновить можно только приостановленную. */
  TaskNotPaused = 'TASK_NOT_PAUSED',
  /** TASK-UC-5: подряд много ошибок шагов. */
  TaskTooManyFailures = 'TASK_TOO_MANY_FAILURES',

  // backups (OPS-UC-8…11)
  BackupNotFound = 'BACKUP_NOT_FOUND',
  /** OPS-UC-10.CC-1, OPS-UC-11.CC-3: не копия или данные копии не загружаются. */
  BackupInvalid = 'BACKUP_INVALID',
  /** OPS-UC-9.CC-1: копию сейчас создают или восстанавливают. */
  BackupInUse = 'BACKUP_IN_USE',
  /** OPS-UC-11.CC-1: на платформе есть незавершённые фоновые задачи. */
  BackupTasksActive = 'BACKUP_TASKS_ACTIVE',
  /** OPS-UC-11.CC-2: копия от более новой версии сайта. */
  BackupNewerVersion = 'BACKUP_NEWER_VERSION',
  /** OPS-UC-11.CC-4: контрольная сумма файла в архиве не сходится. */
  BackupFileCorrupted = 'BACKUP_FILE_CORRUPTED',

  // system
  DatabaseUnavailable = 'DATABASE_UNAVAILABLE',
  StorageUnavailable = 'STORAGE_UNAVAILABLE',
  DatasetDatabaseNotEmpty = 'DATASET_DATABASE_NOT_EMPTY',
  SettingNotFound = 'SETTING_NOT_FOUND',
  ConfigValueInvalid = 'CONFIG_VALUE_INVALID',
  ConfigNotEditable = 'CONFIG_NOT_EDITABLE',
  /** DEMO-RULE-4, DEMO-RULE-1: в демо-режиме это не меняется — демо общее для всех посетителей. */
  DemoProtected = 'DEMO_PROTECTED',
}

export const ALL_ERROR_CODES: readonly ErrorCode[] = Object.values(ErrorCode);
